import React from 'react';
import PropTypes from 'prop-types';

import { Banner, Flex } from '@zillow/constellation';
import { Text } from '@zillow/constellation-10';

export default class Contact extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    reportSpam: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.redirectToProperties = this.redirectToProperties.bind(this);
    this.decrementSecond = this.decrementSecond.bind(this);

    this.state = {
      redirectTimeout: setTimeout(this.redirectToProperties, 3000),
      timerInterval: setInterval(this.decrementSecond, 1000),
      time: 3,
    };
  }

  componentDidMount() {
    this.props.reportSpam();
  }

  componentWillUnmount() {
    clearTimeout(this.state.redirectTimeout);
    clearInterval(this.state.timerInterval);
  }

  decrementSecond() {
    this.setState((prevState) => ({
      time: prevState.time - 1,
    }));
  }

  redirectToProperties() {
    if (typeof window !== 'undefined') {
      window.router.transitionTo('/rental-manager/properties');
    }
  }

  render() {
    const { name, date } = this.props;
    const { time } = this.state;
    const spamText = `Message from ${name} on ${date} marked as spam.`;
    const redirectText = `Thanks! We are redirecting you to your properties in ${time} seconds...`;

    return (
      <React.Fragment>
        <Banner appearance="success" body={spamText} />
        <Flex display="flex" justifyContent="center" paddingTop="md">
          <Text>{redirectText}</Text>
        </Flex>
      </React.Fragment>
    );
  }
}
